import * as dayjs from 'dayjs';
import { apiDateFormat } from './consts';

/**
 * This is used to dynamically create types at runtime, mostly by the data service.
 * @param type the Type to create
 */
export function create<T>(type: (new () => T)): T {
  return new type();
}

/**
 * This returns a timeout as a promise.
 * @param ms the number of milliseconds to wait
 */
export async function delay(ms: number): Promise<any> {
  return new Promise(resolve => setTimeout(resolve, ms));
}

/**
 * Converts a data into a readable string in the format "MM/DD/YYYY • h:mm:ss a"
 * @param dateStr the date as a string
 */
export function getDateTimeStr(dateStr: string): string {
  if (dateStr) {
    const date = dayjs(dateStr);

    return date.format('MM/DD/YYYY • h:mm:ss a');
  } else {
    return '';
  }
}

/**
 * Converts a number of seconds into a time string in the format "HH:mm:ss".
 * @param time the number of seconds
 */
export function getTimeStr(flightTime: number): string {
  if (flightTime) {
    const numdays = Math.floor(flightTime / 86400);
    const numhours = Math.floor((flightTime % 86400) / 3600);
    const numminutes = Math.floor(((flightTime % 86400) % 3600) / 60);
    const numseconds = Math.floor((flightTime % 86400) % 3600) % 60;
    const days = numdays < 9 ? `0${numdays}` : numdays;
    const hours = numhours < 9 ? `0${numhours}` : numhours;
    const minutes = numminutes < 9 ? `0${numminutes}` : numminutes;
    const seconds = numseconds < 9 ? `0${numseconds}` : numseconds;

    return `${days}:${hours}:${minutes}:${seconds}`;
  } else {
    return '--';
  }
}

/**
 * Use this to get data from the local session storage of the browser.
 * @param key the key to use to retrieve the data
 */
export function getSessionData(key: string): any {
  if (typeof (Storage) !== 'undefined') {
    const value = sessionStorage.getItem(key);
    try {
      return JSON.parse(value);
    } catch {
      return value;
    }
  } else {
    console.warn('This browser does not support local storage.');
  }
}

/**
 * Use this to store data in the local session storage of the browser.
 * @param key the key to use to store the data
 */
export function saveSessionData(key: string, value: any) {
  if (typeof (Storage) !== 'undefined') {
    let strValue;
    if (typeof (value) === 'string') {
      strValue = value;
    } else {
      strValue = JSON.stringify(value);
    }
    sessionStorage.setItem(key, strValue);
  } else {
    console.warn('This browser does not support local storage.');
  }
}

/** Creates a random GUID and returns it as a string. */
export function guidGenerator(): string {
  const S4 = function () {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  };
  return (S4() + S4() + '-' + S4() + '-' + S4() + '-' + S4() + '-' + S4() + S4() + S4());
}

export function firstDayOf(slug: dayjs.UnitType, date: Date = new Date()) {
  return dayjs(date).startOf(slug).format(apiDateFormat);
}

export function lastDayOf(slug: dayjs.UnitType, date: Date = new Date()) {
  return dayjs(date).endOf(slug).format(apiDateFormat);
}

export function geBrowserTimeZoneandOffset() {
	const offset = new Date().getTimezoneOffset(), o = Math.abs(offset);
	return (offset < 0 ? '+' : '-') + ('00' + Math.floor(o / 60)).slice(-2) + ':' + ('00' + (o % 60)).slice(-2);
}

export function getTimeZoneoffset(): number {
	const timeZoneOffset = new Date().getTimezoneOffset();
	const minutes = ((-1) * timeZoneOffset);
	return minutes;
}

export function getDateFormat_MMddyyyyhhmmss(input) {
	const d = new Date(input);
	const y = d.getFullYear(), mon = (d.getMonth() + 1), dy = d.getDate(), h = d.getHours(), min = d.getMinutes(), ss = d.getSeconds();

	const dateformat = [('0' + mon.toString()).slice(-2), ('0' + dy.toString()).slice(-2), (y.toString())];
	const timeformat = [('0' + h.toString()).slice(-2), ('0' + min.toString()).slice(-2), ('0' + ss.toString()).slice(-2)];
	const dt = dateformat.join('/') + ' ' + timeformat.join(':');

	return dt;
}
